/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, September 2021
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import Select from 'react-select';

import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { PanelStyle } from '../../../constants';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { replaceMultipleSpaces } from '../../../lib/utils';
import { fetchDistrictServices } from '../../../actions/district';
import v from '../../eservices/validators';
import ModalAlert from '../../eservices/ModalAlert';

import styles from './ServiceCardsEditor.css';


const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const btnStyle = {
  width: '100%',
};

const labels = {
  organ: 'Organ właściwy do realizacji usługi:',
  dotyczy: 'Kogo dotyczy:',
  podstawa: 'Podstawy prawne:',
  dokumenty: 'Wymagane dokumenty:',
  czas: 'Czas realizacji:',
  oplaty: 'Opłaty:',
  tryb: 'Tryb odwoławczy:',
  rezultat: 'Rezultat realizacji usługi:',
  etapy: 'Etapy realizacji usługi:',
  poziom_uwierzytelniania: 'Poziom uwierzytelniania:',
  logowanie: 'Usługa wymaga zalogowania:',
};

const loggingOptions = [
  {
    state: 'logowanie',
    value: 'TAK',
    label: 'TAK',
  },
  {
    state: 'logowanie',
    value: 'NIE',
    label: 'NIE',
  },
];

class ServiceCardsEditor extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    districts: PropTypes.object,
  };

  state = {
    selected_district: null,
    editMode: null,
    filter_text: '',
    service_filter_text: '',
    all_services: [],
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    isEditingData: false,
    showModal: false,
    defaultData: {
      organ: '',
      dotyczy: '',
      podstawa: [],
      dokumenty: [],
      czas: '',
      oplaty: [],
      tryb: '',
      rezultat: '',
      etapy: [],
      poziom_uwierzytelniania: [],
      logowanie: '',
    },
    cardInfo: {
      organ: '',
      dotyczy: '',
      podstawa: [],
      dokumenty: [],
      czas: '',
      oplaty: [],
      tryb: '',
      rezultat: '',
      etapy: [],
      poziom_uwierzytelniania: [],
      logowanie: '',
    },
  };

  validators = {
    organ: [v.NotNull],
    dotyczy: [v.NotNull],
    podstawa: [v.NotNull],
    dokumenty: [v.NotNull],
    czas: [v.NotNull],
    oplaty: [v.NotNull],
    tryb: [v.NotNull],
    rezultat: [v.NotNull],
    etapy: [v.NotNull],
    poziom_uwierzytelniania: [v.NotNull],
    logowanie: [v.NotSelected],
  };

  componentDidMount = () => {
    this.setStyle();
  }

  setStyle = () => {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style }, () => this.getDataForCard());
  }

  getDataForCard = () => {
    fetch(`${process.env.API_URL}/eservices/service_card/${this.props.district}/${this.props.serviceType}/`)
    .then(r => r.json())
    .then(resp => {
      this.setState({ cardInfo: resp, defaultData: resp });
    });
  }

  sendNewCardData = () => {
    const data = JSON.stringify(this.state.cardInfo);
    const successMessage = 'Zmiany zostały zapisane. Wymagane jest odświeżenie strony.';
    const failureMessage = 'Wystąpił błąd przy zapisie zmian.';
    fetch(`${process.env.API_URL}/eservices/service_card/update/${this.props.district}/${this.props.serviceType}/`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          errorText: successMessage,
          errorTitle: 'Zmiany zapisane.',
          showError: true,
        });
        window.location.reload();
      } else {
        this.setState({
          errorText: failureMessage,
          errorTitle: 'Błąd przy zapisywaniu zmian.',
          showError: true,
        });
      }
    });
  }

  onChange = (e) => {
    const name = e.target.name;
    this.setState(
      {
        cardInfo: {
          ...this.state.cardInfo,
          [name]: e.target.value,
        },
      },
      () => this.validate('cardInfo', name),
    );
  };

  onChangeSelect = (e) => {
    const name = e.state;
    this.setState(
      {
        cardInfo: {
          ...this.state.cardInfo,
          [name]: e.value,
        },
      },
      () => this.validate('cardInfo', name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      if (!['podstawa', 'dokumenty', 'etapy', 'oplaty', 'poziom_uwierzytelniania'].includes(f)) {
        const checks = this.validateField(group, f);
        errors[f] = checks;
      }
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field && Object.keys(this.validators).indexOf(field) > -1) {
      const checks = this.validateField(group, field);
      newState = {
        errors: {
          ...this.state.errors,
          [field]: checks,
        },
      };
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['cardInfo'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        let errors = {};
        const grupy = ['podstawa', 'dokumenty', 'etapy', 'oplaty', 'poziom_uwierzytelniania'];
        for (const g of grupy) {
          const err = this.validateListGroups(g);
          errors = { ...errors, ...err };
        }
        newState = { errors: { ...newState.errors, ...errors } };
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  getInputWithError = (field, value) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{labels[field]}</label>
      </div>
      <div className={inputCol}>
        <div style={{ textAlign: 'justify' }}>
          <input
            disabled={!this.state.isEditingData}
            type="text"
            className="form-control"
            name={field}
            style={{
              width: '100%',
              borderColor: this.getBorderColor(field),
            }}
            value={value}
            placeholder={'Wprowadź...'}
            onChange={(e) => this.onChange(e, field)}
          />
          {/* RENDER ERROS IN SPAN */}
          {this.renderErrors(field)}
        </div>
      </div>
      <div className={rightCol} />
    </div>
  )

  getTextAreaWithError = (field, value) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{labels[field]}</label>
      </div>
      <div className={inputCol}>
        <div style={{ textAlign: 'justify' }}>
          <textarea
            disabled={!this.state.isEditingData}
            type="text"
            className="form-control"
            name={field}
            style={{
              width: '100%',
              borderColor: this.getBorderColor(field),
            }}
            value={value}
            placeholder={'Wprowadź...'}
            onChange={(e) => this.onChange(e, field)}
          />
          {/* RENDER ERROS IN SPAN */}
          {this.renderErrors(field)}
        </div>
      </div>
      <div className={rightCol} />
    </div>
  )

  getPositionInputWithError = (group, idx, value) => (
    <div style={{ textAlign: 'justify' }}>
      <textarea
        disabled={!this.state.isEditingData}
        type="text"
        className="form-control"
        name={`${group}_${idx}`}
        style={{
          width: '100%',
          borderColor: this.getBorderColor(`${group}${idx}`),
        }}
        value={value}
        placeholder={''}
        onChange={(e) => this.onChangePosition(e, group, idx)}
      />
      {/* RENDER ERROS IN SPAN */}
      {this.renderErrors(`${group}${idx}`)}
    </div>
  )

  getSelectWithError = (field, value, options) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{labels[field]}</label>
      </div>
      <div className={inputCol}>
        <div style={{ textAlign: 'justify' }}>
          <Select
            disabled={!this.state.isEditingData}
            noResultsText={'brak wyników'}
            clearable={false}
            options={options}
            value={value}
            placeholder={'Wybierz z listy...'}
            onChange={e => this.onChangeSelect(e, field)}
            style={{
              width: '100%',
              borderColor: this.getBorderColor(field),
            }}
            onBlur={event => event.preventDefault()}
            optionClassName="needsclick"
            blurInputOnSelect={false}
          />
          {/* RENDER ERROS IN SPAN */}
          {this.renderErrors(field)}
        </div>
      </div>
      <div className={rightCol} />
    </div>
  )

  renderGroup = (group) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{labels[group]}</label>
      </div>
      <div className={inputCol}>
        <div style={{ textAlign: 'justify' }}>
          <div className="col-sm-3">
            <button
              disabled={!this.state.isEditingData}
              type="submit-lg"
              className={'btn btn-primary'}
              style={{ float: 'right', ...btnStyle }}
              onClick={() => this.addPosition(group)}
            >
              Dodaj
            </button>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">LP</th>
                <th scope="col">Wartość</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {this.state.cardInfo[group].map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      {this.getPositionInputWithError(group, i, v)}
                    </td>
                    <td>
                      <button
                        disabled={!this.state.isEditingData}
                        type="submit-lg"
                        className={'btn btn-danger'}
                        style={{ btnStyle }}
                        onClick={() => this.removePosition(i, group)}
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className={rightCol} />
    </div>

  )

  addPosition = (state) => {
    const cardInfo = this.state.cardInfo;
    cardInfo[state] = [...cardInfo[state], ''];
    this.setState({ cardInfo });
  }

  removePosition = (i, state) => {
    const cardInfo = this.state.cardInfo;
    const list = [...cardInfo[state]];
    if (i > -1) {
      list.splice(i, 1);
    }
    cardInfo[state] = list;
    this.setState({ cardInfo });
  }

  onChangePosition = (e, state, index) => {
    const cardInfo = this.state.cardInfo;
    const arr = cardInfo[state];
    arr[index] = e.target.value;

    cardInfo[state] = arr;

    this.setState({
      cardInfo,
    }, () => this.validatePositions(state, index),
    );
  }

  validatePositions = (group = null, index = null) => {
    let newState = null;
    if (group) {
      const checks = this.validatePositionField(group, index);
      newState = {
        errors: {
          ...this.state.errors,
          [`${group}${index}`]: checks,
        },
      };
    } else {
      let errors = {};
      const grupy = ['podstawa', 'dokumenty', 'etapy', 'oplaty', 'poziom_uwierzytelniania'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...this.state.errors, ...errors } };
    }
    if (newState) {
      this.setState(newState);
    }
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state.cardInfo[group]) {
      for (const obj of this.state.cardInfo[group]) {
        const checks = this.validatePositionField(group, idx);
        errors[`${group}${idx}`] = checks;
        idx += 1;
      }
    }
    return errors;
  };

  validatePositionField = (group, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(group) > -1) {
      for (const validator of this.validators[group]) {
        const check = validator(this.state.cardInfo[group][index]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  districtFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ service_filter_text: value });
  };

  editModeChange = (editMode) => {
    this.setState({ editMode, selected_district: null });
  };

  onClick = (item) => {
    const prefix = this.props.districts[item].prefix;
    this.setState({ selected_district: prefix });
  };

  dataEdit = () => {
    const data = cloneDeep(this.state.defaultData);
    this.setState({
      isEditingData: !this.state.isEditingData,
      cardInfo: data,
    });
  }

  validateBeforeModal = () => {
    this.validate(null, null, this.checkFieldErrors);
  }

  checkFieldErrors = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    this.showModalAlert();
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  onHide = () => this.setState({ showError: false });

  // modal z potwierdzeniem lub odrzuceniem zmian
  confirmModal = () => {
    return (
      <div className={styles.modal}>
        <div className={styles.modal__container} style={this.state.style}>
          <div className={styles.modal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={styles.cardButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.sendNewCardData} className={`btn btn-success ${styles.cardButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>

    );
  }

  getBorderColor = (field) => {
    let color = '#ccc';
    if (Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0) {
      color = 'red';
    }
    return color;
  }


  renderErrors = (field) => {
    if (Object.keys(this.state.errors).indexOf(`${field}`) > -1 &&
    this.state.errors[`${field}`] !== null &&
    this.state.errors[`${field}`].length > 0) {
      return (this.state.errors[`${field}`].map((val, index) => (
        <span key={index} style={errorSpanStyle}>
          {val}
        </span>
        ))
      );
    }
  }

  render() {
    return (
      <div className={styles.cardContainer} style={this.state.style}>
        <PaperHeader title="Edycja kart eusług" />
        <PaperHeader title={this.props.eservices[this.props.serviceType].title} />

        <div className="paper-area" style={this.state.style}>
          {this.getTextAreaWithError('organ', this.state.cardInfo.organ)}
          <div className="eus-specs">
            <hr />
          </div>
          {this.getTextAreaWithError('dotyczy', this.state.cardInfo.dotyczy)}
          <hr />
          {this.renderGroup('podstawa')}
          <hr />
          {this.renderGroup('dokumenty')}
          <hr />
          {this.getTextAreaWithError('czas', this.state.cardInfo.czas)}
          <hr />
          {this.renderGroup('oplaty')}
          <hr />
          {this.getTextAreaWithError('tryb', this.state.cardInfo.tryb)}
          <hr />
          {this.getTextAreaWithError('rezultat', this.state.cardInfo.rezultat)}
          <hr />
          {this.renderGroup('etapy')}
          <hr />
          {this.renderGroup('poziom_uwierzytelniania')}
          <hr />
          {this.getSelectWithError('logowanie', this.state.cardInfo.logowanie, loggingOptions)}
          <br />

          <button onClick={this.dataEdit} className="btn btn-warning">{this.state.isEditingData ? 'Anuluj edycję' : 'Edytuj dane'}</button>
          {JSON.stringify(this.state.cardInfo) !== JSON.stringify(this.state.defaultData) ?
            <button onClick={this.validateBeforeModal} className="btn btn-success">Zapisz zmiany</button>
            :
            null
          }
          <br />
          <br />

          {this.state.showModal ? this.confirmModal() : null}
          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices,
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles(styles)(connect(mapState, mapDispatch)(ServiceCardsEditor));



// WEBPACK FOOTER //
// src/routes/admin/service_cards_editor/ServiceCardsEditor.js